import React, { useState, useEffect, useRef } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import CommonDatePicker from '../datepicker/CommonDatePicker';
import 'rsuite/dist/rsuite.min.css';
import { API_URL } from '../Config';
import config from "../common/Config";
import * as XLSX from 'xlsx';

const BatchWiseStockReport = () => {
    const [reportrange, setReportrange] = useState('');
    const [dates, setDates] = useState([null, null]);
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [brandOptions, setBrandOptions] = useState([]);
    const [salescategory, setSalescategory] = useState('');
    const [salesbrand, setSalesbrand] = useState('');
    const [recordsTotal, setRecordsTotal] = useState('');
    const accessToken = localStorage.getItem('accessToken');
    const salesOrderRef = useRef(null);

    const handleDateChange = (value) => {
        setDates(value);
        let formattedStartDate = value[0] ? format(value[0], 'MM/dd/yyyy') : '';
        let formattedEndDate = value[1] ? format(value[1], 'MM/dd/yyyy') : '';
        setReportrange(formattedStartDate ? `${formattedStartDate} - ${formattedEndDate}` : '');
    };

    const fetchCategoriesOptions = async () => {
        try {
            const res = await fetch(`${API_URL}/stock_take/getCategories`, {
                method: 'POST',
                headers: { authorization: `Bearer ${accessToken}` }
            });
            const data = await res.json();
            setCategoryOptions(data.data.category.map(item => ({ value: item.id, label: item.name })));
        } catch (err) {
            console.error('Category fetch failed', err);
        }
    };

    const fetchBrandOptions = async () => {
        try {
            const res = await fetch(`${API_URL}/stock_take/getBrands`, {
                method: 'POST',
                headers: { authorization: `Bearer ${accessToken}` }
            });
            const data = await res.json();
            setBrandOptions(data.data.brands.map(item => ({ value: item.id, label: item.name })));
        } catch (err) {
            console.error('Brand fetch failed', err);
        }
    };

    const fetchReport = () => {
        const $table = $(salesOrderRef.current);
        const searchValue = $('#searchValue').val();

        if ($.fn.DataTable.isDataTable($table)) {
            $table.DataTable().destroy();
        }

        $table.DataTable({
            processing: true,
            serverSide: true,
            ajax: {
                url: `${config.API_URL}/batchWiseStockReport`,
                type: 'POST',
                headers: {
                    authorization: `Bearer ${accessToken}`,
                },
                data: function (d) {
                    return $.extend({}, d, {
                        draw: d.draw,
                        start: d.start,
                        length: d.length,
                        searchValue,
                        reportrange,
                        brand_id: salesbrand,
                        category_id: salescategory,
                    });
                },
                dataSrc: function (json) {
                    // Set totals from API response
                    $('#totalBatch').html(parseFloat(json.total_batches || 0).toFixed(2));
                    $('#totalBoxQty').html(parseFloat(json.total_box_qty || 0).toFixed(2));
                    $('#totalPiecesQty').html(parseFloat(json.total_piece_qty || 0).toFixed(2));
                    setRecordsTotal(json.recordsTotal);
                    return json.data || [];
                }
            },
            columns: [
                { data: null, title: 'Sr. No.', orderable: false, width: '50px' },
               { 
                data: 'product_code', 
                title: 'Code',
                render: function(data, type, row) {
                    // Replace URL with your actual route
                    return '<a href="/reports/batchWise_stock_details_report/' + row.product_id + '">' + data + '</a>';
                }
            },

                { data: 'product_name', title: 'Name' },
                { data: 'categories', title: 'Category' },
                { data: 'brand', title: 'Brand' },
                { data: 'total_batches', title: 'Total Batch' },
                { data: 'total_box_qty', title: 'Total Box Qty' },
                { data: 'total_piece_qty', title: 'Total Piece Qty' }
            ],
            columnDefs: [
                {
                    targets: 0,
                    orderable: false,
                    className: 'text-center',
                    width: '50px',
                    createdCell: function (td, cellData, rowData, row) {
                        $(td).html(row + 1);
                    }
                },
                {
                    targets: 2,
                    width: '300px'
                }
            ],
            pageLength: 50,
        });
    };

    useEffect(() => {
        fetchReport();
        fetchCategoriesOptions();
        fetchBrandOptions();
    }, [reportrange]);

   

    const searchFormData = () => {
        fetchReport();
    };

    return (
        <div>
            <Header />
            <div className="breadcrumbs">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <Link to="/Dashboard"><i className="fa fa-home"></i></Link>
                            <Link to="/reports/inventory_sales_report">Reports</Link>
                            <Link to="/reports/sales_product_report">Stock Report</Link>
                        </div>
                    </div>
                </div>
            </div>

            <div className="main-container">
                <div className="container-fluid">
                    <div className="row align-items-end mb-3">
                        <div className="col-md-3">
                            
                            <CommonDatePicker
                                value={dates}
                                 showOneCalendar
                                // placeholder="DD/MM/YYYY - DD/MM/YYYY"
                                onChange={handleDateChange}
                                format="dd/MM/yyyy"
                                character=" - "
                                style={{ width: '100%' }}
                            />
                        </div>

                        <div className="col-md-3">
                            
                            <select value={salescategory} onChange={(e) => setSalescategory(e.target.value)} className="form-control">
                                <option value="">Select Category</option>
                                {categoryOptions.map(opt => (
                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                ))}
                            </select>
                        </div>

                        <div className="col-md-3">
            
                            <select value={salesbrand} onChange={(e) => setSalesbrand(e.target.value)} className="form-control">
                                <option value="">Select Brand</option>
                                {brandOptions.map(opt => (
                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                ))}
                            </select>
                        </div>

                        <div className="col-md-1">
                            <button type="button" onClick={searchFormData} className="acceptbtn">
                                Submit
                            </button>
                        </div>

                       
                    </div>

                    {/* Table */}
                    <div className="dashboard mt-4">
                    
                        <div className="verical-scrl-wrapper common-table autoheight-table salesproduct" id="style-3">
                        <div className="table-responsive">
                            <table ref={salesOrderRef} className="table table-bordered resizable" id="inventorySalesReport" style={{ minWidth: '1200px' }}>
                                <thead>
                                    <tr>
                                        <th>Sr. No.</th>
                                        <th>Code</th>
                                        <th>Name</th>
                                        <th>Category</th>
                                        <th>Brand</th>
                                        <th>Total Batch</th>
                                        <th>Total Box Qty</th>
                                        <th>Total Piece Qty</th>
                                       
                                    </tr>
                                </thead>
                                <tfoot>
                                    <tr>
                                        <th colSpan="5" className="text-end">Total:</th>
                                        <th id="totalBatch">0</th>
                                        <th id="totalBoxQty">0</th>
                                        <th id="totalPiecesQty">0</th>
                                    </tr>
                                </tfoot>
                                <tbody></tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
    <Footer />
        </div>
    );
};



export default BatchWiseStockReport;
